import { render, staticRenderFns } from "./Pre.vue?vue&type=template&id=ca89c100"
import script from "./Pre.vue?vue&type=script&lang=js"
export * from "./Pre.vue?vue&type=script&lang=js"
import style0 from "./Pre.vue?vue&type=style&index=0&id=ca89c100&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports